let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i2nFm")).then(() => parcelRequire('cU1zD'));